import { Button } from "@/components/shared/Button";
import { PortfolioFeaturedTokenCard } from "./PortfolioFeaturedTokenCard";
import { usePortfolioTokenCards, type PortfolioTokenCard } from "./usePortfolioTokenCards";
import { memo } from "react";

export const PortfolioYourTokensSection = memo(() => {
    const { cards } = usePortfolioTokenCards();
    return (
        <section>
            <div className="grid grid-cols-2 items-center justify-between gap-10">
                <h2 className="text-[24px] font-medium text-primary mb-4 whitespace-nowrap">Your tokens</h2>
                <span className="flex items-center gap-4 justify-end">
                    <span className="leading-[14px] text-[12px] md:text-[14px] text-dark text-right">
                        Help determine where iUSD deploys its backing.
                    </span>
                    <Button size="sm" variant="primary" href="/vote">
                        Vote
                    </Button>
                </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {cards.map((tokenCard: PortfolioTokenCard) => (
                    <PortfolioFeaturedTokenCard key={tokenCard.tokenId} {...tokenCard} />
                ))}
            </div>
        </section>
    );
});

PortfolioYourTokensSection.displayName = "PortfolioYourTokensSection";
